export const jobMap = {
  ALC: 'alchemy',
  Alchemist: 'ALC',
  ARM: 'armory',
  Armorer: 'ARM',
  BSM: 'blacksmithing',
  Blacksmith: 'BSM',
  CRP: 'carpentry',
  Carpenter: 'CRP',
  CUL: 'culinary',
  Culinarian: 'CUL',
  GSM: 'goldsmithing',
  Goldsmith: 'GSM',
  LTW: 'leatherworking',
  Leatherworker: 'LTW',
  WVR: 'weaving',
  Weaver: 'WVR',
  BTN: 'botany',
  Botanist: 'BTN',
  FSH: 'fishing',
  Fisher: 'FSH',
  MIN: 'mining',
  Miner: 'MIN'
}

export default {
  jobMap
}



// WEBPACK FOOTER //
// ./src/utils/enums.js